import {DAYS_OF_WEEK} from "../grounds/constants";

export function generateHourlySlots(openingTime, closingTime, slotDurationMinutes = 60, slotPrice = 1000) {
  if (!openingTime || !closingTime) return {};
  const slots = {};
  const opening = new Date(`2000-01-01T${openingTime}:00`);
  const closing = new Date(`2000-01-01T${closingTime}:00`);
  DAYS_OF_WEEK.forEach(day => {
    slots[day] = [];
    let currentTime = new Date(opening);
    while (currentTime < closing) {
      const startTime = currentTime.toTimeString().slice(0, 5);
      currentTime = new Date(currentTime.getTime() + slotDurationMinutes * 60000);
      const endTime = currentTime.toTimeString().slice(0, 5);
      if (currentTime <= closing) {
        slots[day].push({ start_time: startTime, end_time: endTime, price: slotPrice });
      }
    }
  });
  return slots;
}
